<template>
    <div class="term-container">
      <div class="text-a-center">
        <img :src="image" width="100" height="auto" />
        </div>
        <h2 class="text-a-center">Terms and Conditions</h2>
        <div class="tex-container">
         <p>
            These Terms of Use apply to your access to and use
            of the webapp and other online products and services
            ("Services") provided by Cycle AI, LDA ("CycleAI",
            "we", "us", "our"). The use of our Services assumes
            the acceptance of these Terms of Use, which can be
            consulted at all times. The use of our Services
            implies agreement with these Terms of Use, so you
            should not use the Services if you do not agree with
            the Terms of Use.
          </p>
          <p class="font-weight-bold">1. Service Usage</p>
          <p>
            CycleAI grants you a personal, royalty-free,
            revocable, non-transferable, limited license to use
            our Services. We reserve all rights not expressly
            granted to you by these Terms of Use.
          </p>
          <p>
            We do not guarantee that the Services will always be
            available or uninterrupted. We are always improving
            our Services, so we may add or remove features,
            products or functionality. We reserve the right to
            modify, suspend, or discontinue the Services, in
            whole or in part, at any time, with or without
            notice to you. Any future updates will be subject to
            these Terms of Use, which may be updated from time
            to time. We will not be liable to you or any third
            party for any modification, suspension, or
            discontinuance of the Services or any part thereof.
          </p>

          <p class="font-weight-bold">2. Privacy</p>
          <p>
            CycleAI takes the protection of your privacy as a
            fundamental commitment. In our Privacy Policy we
            explain what kind of personal data we collect, how
            we treat such information, with which entities we
            may share personal data, the rights granted to you
            and how you can contact us.
          </p>

          <p class="font-weight-bold">
            3. Update of the Terms of Use
          </p>
          <p>
            CycleAI reserves the right to change these Terms of
            Use in order to reflect the evolution of the
            Services, and therefore recommends users to visit
            them periodically. No changes will be applied
            retroactively. By continuing to access or use the
            Services after the revised Terms of Use, you agree
            to be bound by the revised Terms of Use. If you do
            not agree to the revised Terms of Use, you should
            stop accessing and using our Services.
          </p>

          <p class="font-weight-bold">4. Disallowed Conducts</p>
          <ul class="mb-16">
            <li>
              Unless the restrictions we identify below are
              impermissible under applicable law, you may not,
              without our prior written agreement:
            </li>
            <li>
              Use our Services in an unlawful, abusive,
              fraudulent, or harmful manner;
            </li>
            <li>
              Use the Services in any manner that could disable,
              disrupt, overburden, or otherwise interfere with
              or impair the Services;
            </li>
            <li>
              Monitor the availability, performance or
              functionality of the Services for any purpose,
              including, but not limited to, competitive
              purposes or to test system security;
            </li>
            <li>
              Post or download content that contains software
              viruses, worms or other malicious code intended to
              interfere with the Services;
            </li>
            <li>
              Rent, assign, distribute, host, market, sell or
              otherwise monetize our Services or access to them,
              including related data
            </li>
            <li>
              Obtain or attempt to obtain access to any
              non-public areas or components of the Services;
            </li>
            <li>
              Reverse engineer, decompile, disassemble, decrypt,
              or otherwise attempt to extract the source code of
              the application or any related technology;
            </li>
            <li>
              Use our Services in violation of applicable law or
              to infringe the intellectual property rights of
              any person or entity, or any other proprietary
              rights;
            </li>
            <li>
              Access, search, or collect data from the Services
              by any means (automated or otherwise) except as
              permitted in these Terms or by obtaining prior
              authorization from CycleAI;
            </li>
            <li>
              Use the Services in any manner that we reasonably
              believe to be an abuse or fraud;
            </li>
            <li>
              Simulate, in any form and by any means, the
              appearance or function of our Services.
            </li>
          </ul>

          <p class="font-weight-bold">5. Third-Party Content</p>
          <p>
            The Services may contain links to third party
            websites, products, or services. Third party content
            is not under CycleAI's control, and we are not
            responsible for any third party websites, products,
            or services. If you decide to access any other
            websites linked to or from our Services, you do so
            at your own risk.
          </p>

          <p class="font-weight-bold">6. Property</p>
          <p>
            The content featured on our Services is the property
            of CycleAI or its content providers. The Services
            are owned and operated by CycleAI. The visual
            interfaces, graphics, design, compilation,
            information, data, computer code, products,
            services, trademarks and all other elements of the
            Services ("Materials") provided by CycleAI are
            protected by intellectual property laws and other
            legislation. All Materials included in the Services
            are the property of CycleAI or its licensors. You do
            not acquire any ownership rights by using our
            Services and, except asexpressly authorized in
            advance in writing by CycleAI, you may not make use
            of our Materials.
          </p>

          <p class="font-weight-bold">
            7. Limitation of Liability
          </p>
          <p>
            By using the Services, you agree that CycleAI's
            liability is limited to the maximum extent permitted
            in your country of residence. CycleAI does not
            warrant that the Services will be free of
            interruptions or errors and offers the Services on
            an "as is" basis. Within the limits of applicable
            law, CycleAI will not be liable to users for any
            damages, indirect, incidental, resulting directly or
            indirectly from use of the application, as well as
            for losses that are the responsibility of the user
            or third parties, for losses arising from force
            majeure or for losses resulting from interference or
            failures in the operating system that may prevent
            users from accessing and using the application. This
            limitation of liability shall not apply to any
            mandatory liability which cannot be limited.
          </p>

          <p class="font-weight-bold">8. General</p>
          <p>
            The failure of CycleAI to exercise any right or
            provision of these Terms of Use shall not constitute
            a waiver of such right or provision. If any
            provision of these Terms of Use is held invalid or
            unenforceable, that provision shall be deemed
            severable to its scope and extent and all other
            provisions shall remain valid and enforceable.
          </p>

          <p class="font-weight-bold">9. Contacts</p>
          <p>
            To clarify any question related to these Terms of
            Use, you can contact us:
          </p>
          <p class="mb-0">CycleAI, LDA</p>
          <p>
            Email :
            <a
              href="mailto:contact@cycleai.net"
              class="set-a-color"
              >contact@cycleai.net</a
            >
          </p>
          </div>
    </div>
</template>
<script>
import image from '@/assets/img/CycleAI favicon black (3).png'
export default {
  data: () => ({
    image
  }),
}
</script>